import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';

const styles = StyleSheet.create({
    wrapper: {
        // // paddingTop: 12,
        flexDirection: 'row',
        marginBottom: 60,
        // flex: 1,
    },
    headline: {
        fontSize: 24,
        textAlign: 'left',
        fontWeight: 'bold',
        color: '#8babd1',
    },
    subline: {
        fontSize: 16,
        textAlign: 'left',
        color: '#a2bc0c',
    },
    headlineImage: {
        width: 64,
        height: 70,
        // flex: 1
    },
    headlineWrapper: {
        flex: 3,
        width: '50%',
    },
});
const HeaderShort = ({ customerId }) => {
    return (
        <View style={styles.wrapper} fixed>
            <View style={styles.headlineWrapper}>
                <Text style={styles.headline}>Kundenbedarf - Kurzfassung</Text>
                <Text style={styles.subline}>Anfrage für Auftragsnummer: #{customerId}</Text>
            </View>
            <View style={{ flex: 1 }}></View>
            <View>
                <Image src={`${process.env.PUBLIC_URL}/logo.png`} style={styles.headlineImage} />
            </View>
        </View>
    );
};

export default HeaderShort;
